import { getRecords } from './baserow'

export default {
  getSlideshow () {
    return getRecords('Slideshow')
  }
}
